<template>
<div class="content-main">
    <div class="left-main">
        <div class="left-main-content">
            <div class="titile-nav-box mgt55">
                <div class="title" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==0"><span class="colorFB092B">Comprehensive</span> <span>Services</span></div>
                <div class="title" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==1"><span class="colorFB092B">Financial </span> <span>Services</span></div>
                <div class="title" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==2"><span class="colorFB092B">International </span><span>Logistics Services</span></div>

                <div class="btnsList">
                    <div :class="{'btn-child':true,'active-btn':item.isClick}" v-for="item in navList" :key="item.text" @click="changeItem(item)">{{item.text}}</div>
                </div>
            </div>
            <!-- <div class="title mgt80"><span class="colorFB092B">综合</span><span>服务</span></div>
            <div class="sec-title">Supply and <br>
                demand docking</div> -->
            <div class="left-main-box" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==0">
                <div class="left-main-content-2">

                    <div class="sec-title">Our globally comprehensive online foreign trade service system provides manufacturers with one-stop comprehensive services such as customs clearance, foreign exchange settlement, tax refund, logistics and finance. 
                    These will reduce the export transaction cost of the factory, improve user experience and allows the factory to focus on receiving production orders and scale exports while reducing the cost of replacing parts and operations.
                    </div>
                    <div class="text-video-box">
                        <div class="left-nav-box">
                            <div :class="{'nav-child':true,'active-nav':item.isClick}" v-for="(item,index) in childnavList" :key="index" @mouseover="changeNav(item)">
                                <div class="child-left">
                                    <div class="line" v-if="item.isClick==true"></div>
                                    <div class="triangle" v-else></div>
                                    <div class="child-text">{{item.text}}</div>
                                </div>
                                <div class="imgs">
                                    <img :src="item.icon" alt="" width="100%" height="100%" v-if="item.isClick">
                                </div>
                            </div>
                        </div>
                        <div class="right-child-box" v-for="(item,index) in childnavList" :key="index" v-if="item.id==0&&item.isClick">
                            <div class="childList showBox" index="1" style="display: block;">
                                <div class="child-title">Included Services</div>
                                <ul class="serverList_2">
                                    <li>√ Enterprise partners will enjoy a green-lane customs declaration channel.</li>
                                    <li>√ Professional customs clearance service team to solve customs clearance problems for customers. </li>
                                    <li>√ Access to an all-in-one online system with a one-stop online customs declaration service.</li>
                                </ul>
                                <div class="child-title">Service Process</div>
                                <div class="server-img-box"> <img id="" src="../assets/images/com1_1.jpg" alt="" class="server-img" width="50%"></div>
                                <div class="child-title">Terms &amp; Conditions</div>
                                <div>
                                    <ul class="serverList_2">
                                        <li>√ The products entrusted for export are within SCITCS’s export capabilities (Please consult our customer service personnel for details） </li>
                                        <li>√ Customer type: Trader / manufacturer / individual / foreign procurement office. </li>
                                        <li>√ The qualification of drawer must meet the requirements（Please consult the customer service personnel for details） </li>
                                        <li>√ The trade of export goods must be remitted to the designated trade collection account of the foreign comprehensive services.
</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="right-child-box" v-for="(item,index) in childnavList" :key="index" v-if="item.id==1&&item.isClick">
                            <div class="childList" index="3" style="display: block;">
                                <div class="child-title">Service contents</div>
                                <ul class="serverList_2">
                                    <li>√ Goods storage, B2C small package delivery, B2B batch delivery.</li>
                                    <li>√ Multi warehouse data real-time collection.</li>
                                    <li>√ Replenish to FBA / third party overseas warehouse.</li>
                                </ul>
                                <div class="child-title">Service Process</div>
                                <div class="server-img-box"> <img id="" src="../assets/images/com1_2.jpg" alt="" class="server-img" width="50%"></div>
                                <div class="child-title">Service advantage</div>
                                <div>
                                    <ul class="serverList_2">
                                        <li>√ Replenish to FBA / third party overseas warehouse. Fast delivery, wide distribution of overseas warehouses and local distribution in many countries</li>
                                        <li>√ Low cost, collective freight, cost sharing, low logistics cost.</li>
                                        <li>√ Multiple transaction modes can support the storage demand of retail, wholesale and bulk transactions at the same time.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="right-child-box" v-for="(item,index) in childnavList" :key="index" v-if="item.id==2&&item.isClick">
                            <div class="childList" index="4" style="display: block;">
                                <div class="child-title">Service contents</div>
                                <ul class="serverList_2">
                                    <li>√ Safe and efficient; fast settlement with low costs.</li>
                                    <li>√ The trade settlement process is transparent. Log on to the “Financial Centre" on our platform and you can check on the trade details at any time.</li>
                                    <li>√ Direct connection with major banks, online applications, real-time arrivals, and ensured capital security.</li>
                                    <li>√ Meet customer demands, provide forward trade locking service, avoid exchange rate risks and lock profits in advance.</li>
                                </ul>
                                <div class="child-title">Service Process</div>
                                <div class="server-img-box">
                                    <img id="" src="../assets/images/com1_3.jpg" alt="" class="server-img" width="50%"></div>
                            </div>
                        </div>
                        <div class="right-child-box" v-for="(item,index) in childnavList" :key="index" v-if="item.id==3&&item.isClick">
                            <div class="childList" index="5" style="display: block;">
                                <div class="child-title">Service Benefits</div>
                                <ul class="serverList_2">
                                    <li>√ Enjoy the green lane for fast tax rebate.</li>
                                    <li>√ Regular export tax rebates, simplify tax rebate links and revitalize funds.</li>
                                    <li>√ The tax refund shall be paid within 3 working days pending complete documentation.</li>
                                </ul>
                                <div class="child-title">Service Process</div>
                                <div class="server-img-box"> <img id="" src="../assets/images/com1_4.jpg" alt="" class="server-img" width="50%"></div>
                                <div class="child-title">Tax Refund Conditions</div>
                                <div class="server-img-box">
                                    <ul class="serverList_2">
                                        <li>√ Tax refund conditions customers need to meet the following conditions before they can declare a tax refund.</li>
                                    </ul>
                                    <div class="server-img-box"> <img id="" src="../assets/images/com1_5.jpg" alt="" class="server-img" width="50%"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left-main-content-2" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==1">

                <div class="sec-title">The global online foreign trade comprehensive service system provides export factories with one-stop online comprehensive services such as customs clearance, foreign exchange settlement, tax refund, logistics and finance.
                    It can comprehensively reduce the export transaction cost of the factory, improve the user experience, let the factory focus on order receiving production and help Sichuan goods out of Sichuan through scale effect and reduction in replacement parts and operation.
                </div>
                <div class="text-video-box">
                    <div class="left-nav-box">
                        <div :class="{'nav-child':true,'active-nav':item.isClick}" v-for="(item,index) in FinNavList" :key="index" @mouseover="changeNavFin(item)">
                            <div class="child-left">
                                <div class="line" v-if="item.isClick==true"></div>
                                <div class="triangle" v-else></div>
                                <div class="child-text">{{item.text}}</div>
                            </div>
                            <div class="imgs">
                                <img :src="item.icon" alt="" width="100%" height="100%" v-if="item.isClick">
                            </div>
                        </div>
                    </div>
                    <div class="right-child-box" v-for="(item,index) in FinNavList" :key="index" v-if="item.id==0&&item.isClick">
                        <div class="childList showBox" index="1">
                            <div class="child-title">Service Benefits</div>
                            <ul class="serverList_2">
                                <li>√ Low application threshold and unlimited financing amount and number of orders</li>
                                <li>√ After the documents are completed, the funds will be received within three working days</li>
                                <li>√ There is no need for a complex tax refund processes</li>
                            </ul>
                            <div class="child-title">Service Process</div>
                            <div class="server-img-box"> <img id="" src="../assets/images/pic_22.png" alt="" class="server-img" width="50%" height="100%"></div>
                            <div class="child-title">Terms &amp; Conditions</div>
                            <div>
                                <ul class="serverList_2">
                                    <li>◆ The applying enterprise must be a production-oriented general taxpayer enterprise</li>
                                    <li>◆ Export declaration through our platform (subject to the customs declarations forms)</li>
                                    <li>◆ Our platform receives the full foreign exchange</li>
                                    <li>◆ We receive the compliant special VAT invoice on the platform</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="right-child-box" v-for="(item,index) in FinNavList" :key="index" v-if="item.id==1&&item.isClick">
                        <div class="childList" index="2" style="display: block;">
                            <div class="child-title">Service contents</div>
                            <ul class="serverList_2">
                                <li>√ Solve the shortage of raw material funds and improve customers' order receiving ability;</li>
                                <li>√ Enterprises can apply according to credit sales contracts and real and effective purchase orders;</li>
                                <li>√ Our platform advances the corresponding order amount within the buyer's credit line.</li>
                            </ul>
                            <div class="child-title">Service Process</div>
                            <div class="server-img-box"> <img id="" src="../assets/images/pic_25.png" alt="" class="server-img" width="40%" height="50%"></div>
                            <div class="child-title">Access conditions</div>
                            <div>
                                <ul class="serverList_2">
                                    <li>◆ The buyer has passed the amount review of SINOSURE, and the seller has signed a foreign trade custody agreement with our platform;</li>
                                    <li>◆ The seller has historical transaction collection records in the integrated cloud service;</li>
                                    <li>◆ 60% of the maximum advance order amount within the buyer's credit line.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="right-child-box" v-for="(item,index) in FinNavList" :key="index" v-if="item.id==2&&item.isClick">
                        <div class="childList" index="3" style="display: block;">
                            <div class="child-title">Service contents</div>
                            <ul class="serverList_2">
                                <li>√ The service covers two modules: basic L / C service and L / C buyout service, which can be selected flexibly on demand;</li>
                                <li>√ A comprehensive financial service scheme is applicable to any enterprise involved in letter of credit transactions.</li>
                            </ul>
                            <div class="child-title">Service Process</div>

                            <div class="server-img-box">
                                <p>◆ Basis of letter of credit Service Process：</p>
                                <img id="" src="../assets/images/pic_27.png" alt="" class="server-img" width="50%">
                            </div>
                            <div class="server-img-box">
                                <p>◆ L / C buyout Service Process：</p>
                                <img id="" src="../assets/images/pic_28.png" alt="" class="server-img" width="50%">
                            </div>
                            <div class="child-title">Access conditions</div>
                            <div>
                                <ul class="serverList_2">
                                    <li>◆ The customer needs to be a foreign trade export enterprise settled by international letter of credit to meet the cooperation requirements of our platform (i.e. complete the export tax rebate business of at least one foreign integrated cloud service).</li>
                                    <li>◆ The customer needs to be a foreign trade export enterprise settled by international letter of credit to meet the cooperation requirements of our platform (i.e. complete the export tax rebate business of at least one foreign integrated cloud service); If an enterprise needs L / C financing buyout service, it needs to issue a L / C with the beneficiary of waizong cloud service (the type of L / C is irrevocable and irrevocable), and the enterprise needs to be established for more than half a year and have at least one self operated L / C collection record in recent 6 months;</li>
                                    <li>◆ The country issuing the letter of credit must be above the rating of SINOSURE B. for countries or regions below the rating of B, the international bank designated by our company must be the issuing party.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="right-child-box" v-for="(item,index) in FinNavList" :key="index" v-if="item.id==3&&item.isClick">
                        <div class="childList" index="4" style="display: block;">
                            <div class="child-title">Service contents</div>
                            <ul class="serverList_2">
                                <li>√ The country issuing the letter of credit must be above the rating of SINOSURE B. for countries or regions below the rating of B, the international bank designated by our company must be the issuing party. Unsecured, unsecured and pure credit loans with credit lines accumulated by export lines truly realize "credit = wealth".</li>
                                <li>√ The whole process of applying for credit line is free. Within the validity period of 1 year, it can be used at any time according to the capital demand. If it is not used, it will never be charged.</li>
                            </ul>
                            <div class="child-title">Service Process</div>
                            <div class="server-img-box"> <img id="" src="../assets/images/pic_30.png" alt="" class="server-img" width="50%"></div>
                            <div class="child-title">Access conditions</div>
                            <div>
                                <ul class="serverList_2">
                                    <li>◆ The applicant must be a trusteeship cooperative enterprise of our platform (operating on our platform for more than one year and the transaction amount is more than 500000 US dollars), and the export of one US dollar can enjoy a loan limit of up to one yuan, up to 2 million;</li>
                                    <li>◆ The applicant enterprise is not included in the blacklist of defaulting customers of various financial institutions, there are no major environmental protection, debt, tax and other disputes, and the main business of the enterprise does not belong to the industry prohibited and restricted by the state;</li>
                                    <li>◆ The actual controller is willing to sign an unlimited joint and several guarantee contract;</li>
                                    <li>◆ The application period for industrial and commercial registration of enterprises is more than 2 years.</li>
                                </ul>
                            </div>

                        </div>
                    </div>
                    <div class="right-child-box" v-for="(item,index) in FinNavList" :key="index" v-if="item.id==4&&item.isClick">
                        <div class="childList" index="5" style="display: block;">
                            <div class="child-title">Service contents</div>
                            <ul class="serverList_2">
                                <li>√ Export through our platform and entrust our platform to insure;</li>
                                <li>√ Master the real situation of buyers and avoid political risks and foreign exchange risks.</li>
                            </ul>
                            <div class="child-title">Service Process</div>
                            <div class="server-img-box"> <img id="" src="../assets/images/pic_32.png" alt="" class="server-img" width="50%"></div>
                            <div class="child-title">Access conditions</div>
                            <div>
                                <ul class="serverList_2">
                                    <li>◆ For enterprises that have been approved by our platform and settled in our platform, the goods and drawer have passed the filing;</li>
                                    <li>◆ Provide relevant information of the buyer (issuing bank) to our platform;</li>
                                    <li>◆ Provide relevant information of the buyer (issuing bank) to our platform; Time limit for limit application: 3 working days at the fastest (when credit investigation report has been available in the credit insurance system); The fastest time is 7 working days (when there is no existing credit report and it is necessary to start overseas investigation channels).</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="left-main-content-2" v-for="(item,index) in navList" :key="index" v-if="item.isClick&&item.id==2">

                <div class="sec-title">We are committed to improving integrated logistics operation facilities, including the booking system, warehousing, land transportation, coastal transportation, customs declaration and inspection services, and electronic operating system services. We provide a comprehensive logistics platform and continuously optimize logistics solutions for the project customers, thereby enhancing the security and efficiency of the services, whilst for Sea Transport, we provide whole container ocean shipping and LCL services for foreign trade enterprises. The routes from several Chinese ports to America, Europe and other regions are now open. </div>
                <div class="text-video-box_log">
                    <div class="info-box">
                        <swiper :options="swiperOption" ref="swiper">
                            <div class="swiper-button-prev" slot="button-prev" @click="changImgPrev"></div>
                            <div class="swiper-button-next" slot="button-next" @click="changImg"></div>
                            <swiper-slide class="swiper-slide text-boxs" v-for="(item,index) in textList" :key="index">
                                <div class="info-title">{{item.title}}</div>
                                <div class="info-text">{{item.text}}</div>
                                <div class="btns-go" @click="openForm">Register Now</div>
                            </swiper-slide>
                        </swiper>
                        <div class="imgs-list">
                            <div class="imgs-child" v-for="(item,index) in imgsList" :key="index">
                                <img :src="item.icon" alt="" width="100%">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right-main">
        <div class="tagLabel-box">
            <div class="label-top">
                <div :class="{'icon-item':true,'active-icon':item.hasClass}" v-for="(item,index) in list" :key="index" :style="{backgroundImage: `url(${item.hasClass?active_icon:default_icon})`}" @click="changeTag(item)"></div>
            </div>
            <div class="label-bottom">
                <div class="label-bottom-top">
                    <div :class="{'active-child':item.hasClass,'default-child':true}" v-for="(item,index) in list" :key="index" @click="changeTag(item)"></div>
                </div>
                <div class="label-bottom-bottom">
                    <img src="../assets/images/icon_1.png" alt="" width="27px" height="37px">
                </div>
            </div>
        </div>
    </div>
    <div class="user-popuer" v-if="showPopuer">
        <div class="close-icon-box" @click="closeForm">
            <img src="../assets/images/close_2.png" alt="" width="100%" height="100%">
        </div>
        <div class="left-box">
            <div class="title-left">Trade demand is released and solved quickly for you</div>
            <div class="sec-title">After submission, we will quickly respond to your trade needs</div>
            <div class="labels-box mgt15 ">UserName</div>
            <el-input placeholder="Please enter your name" v-model="name" width="80%"></el-input>
            <div class="labels-box mgt15 ">Tel</div>
            <el-input placeholder="It is convenient for business personnel to contact and receive notification information" v-model="name" width="80%"></el-input>
            <div class="labels-box mgt15">Need business</div>
            <el-select class="select-box" v-model="value" filterable placeholder="Quickly select the business you need to handle, or enter it directly" width="80%">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <div class="labels-box mgt15 ">Enterprise Name</div>
            <el-input placeholder="Please enter your business name" v-model="name" width="80%"></el-input>
            <div class="mgt50 submit-btn" @click="goPage">Confirm</div>
        </div>
        <div class="right-box">
            <div class="right-title">Your trusted choice</div>
            <div class="right-text">Provide you with efficient and professional services</div>
            <div class="list-right-box">
                <div class="item-box">
                    <img src="../assets/images/icon_6.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">Rapid response the demand</div>
                        <div class="info-text">Whole business service</div>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/images/icon_7.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">standardized whole process service</div>
                        <div class="info-text">Optimal solution delivery</div>
                    </div>
                </div>
                <div class="item-box">
                    <img src="../assets/images/icon_8.png" alt="" width="40px" height="40px">
                    <div class="item-child-box">
                        <div class="main-title">financial risk control</div>
                        <div class="info-text">Risk control</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import icon_3 from "../assets/images/icon_3.png"
import top_default from "../assets/images/top_default.png"
import top_active from '@/assets/images/top_active.png'
import com_1 from '@/assets/images/com_1.png'
import com_2 from '@/assets/images/com_2.png'
import com_3 from '@/assets/images/com_3.png'
import com_4 from '@/assets/images/com_4.png'
import icon_9 from '@/assets/images/icon_9.png'
import icon_10 from '@/assets/images/icon_10.png'
import icon_11 from "@/assets/images/icon_11.png"
import icon_12 from '@/assets/images/icon_12.png'
import icon_13 from '@/assets/images/icon_13.png'
export default {
    name: "tagSupply",
    props: {
        "vdata": {
            type: Array,
            default: [],
        }

    },
    data() {
        return {
            name: "",
            showPopuer: false,
            swiperOption: {
                slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量; 设置为auto则自动根据slides的宽度来设定数量
                centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
                spaceBetween: 30,
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                //设置点击箭头
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                //自动轮播
                //开启循环模式
                loop: false
            },
            imgsList: [{
                id: 0,
                icon: require("../assets/images/log_1.jpg")
            }, {
                id: 1,
                icon: require("../assets/images/log_2.jpg")
            }, {
                id: 2,
                icon: require("../assets/images/log_3.jpg")
            }, {
                id: 3,
                icon: require("../assets/images/log_4.jpg")
            }],
            textList: [{
                id: 0,
                title: "Ground Transport",
                text: "There are 7 regions in China, covering 28 ports, nearly 26000 lines and special line services; Containers, bulk trucks and bonded supervision vehicles have long-term access to Chengdu and major cities.",
                isShow: true,
            }, {
                id: 1,
                title: "Sea Transport",
                text: "We provide shipping container consolidation and LCL services for foreign trade enterprises.At present, we are cooperating with shipping companies and have opened routes from many ports, from China to America, Europe and other regions.",
                isShow: false
            }, {
                id: 2,
                title: "Rail Transport",
                text: "We provide domestic railway booking, carriage applications, international China-Europe routes, Central Asia routes as well as special line advantages.",
                isShow: false
            }, {
                id: 3,
                title: "Air Transport",
                text: "We provide foreign trade enterprises with international special lines, bags, express and other air transportation services, involving many routes using multiple airlines, and the goods can be tracked and queried in real time.",
                isShow: false,
            }],
            FinNavList: [{
                    id: 0,
                    text: "Export Tax Rebate Advance Payment",
                    isClick: true,
                    icon: icon_13
                },
                {
                    id: 1,
                    text: "Order Financing",
                    isClick: false,
                    icon: icon_9,
                }, {
                    id: 2,
                    text: "Letter of Credit Service",
                    isClick: false,
                    icon: icon_10
                }, {
                    id: 3,
                    text: "Current Loan",
                    isClick: false,
                    icon: icon_11
                }, {
                    id: 4,
                    text: "Export Credit Insurance",
                    isClick: false,
                    icon: icon_12
                }
            ],
            navList: [{
                id: 0,
                text: "Comprehensive Services",
                isClick: true,
            }, {
                id: 1,
                text: "Financial Services",
                isClick: false,
            }, {
                id: 2,
                text: "International Logistics Services",
                isClick: false
            }],
            list: [],
            childnavList: [{
                    id: 0,
                    text: "Intelligent Customs Clearance",
                    isClick: true,
                    icon: com_1
                },
                {
                    id: 1,
                    text: "Overseas Warehousing",
                    isClick: false,
                    icon: com_2,
                }, {
                    id: 2,
                    text: "Trade Settlement",
                    isClick: false,
                    icon: com_3
                }, {
                    id: 3,
                    text: "Tax Refund",
                    isClick: false,
                    icon: com_4
                }
            ],
            input2: "",
            newsList: [{
                    id: 0,
                    text: "·【平台推荐】四川成都至美国出口船运服务提前预定",
                    date: "2021/09/15 截止",
                },
                {
                    id: 1,
                    text: "·【平台推荐】四川成都至美国出口船运服务提前预定",
                    date: "2021/09/15 截止",
                },
                {
                    id: 2,
                    text: "·【平台推荐】四川成都至美国出口船运服务提前预定",
                    date: "2021/09/15 截止",
                },
                {
                    id: 3,
                    text: "·【平台推荐】四川成都至美国出口船运服务提前预定",
                    date: "2021/09/15 截止",
                },
                {
                    id: 4,
                    text: "·【平台推荐】四川成都至美国出口船运服务提前预定",
                    date: "2021/09/15 截止",
                }
            ],
            options: [{
                value: '选项1',
                label: 'Export tax declaration'
            }, {
                value: '选项2',
                label: 'Cross border Logistics'
            }, {
                value: '选项3',
                label: 'Customs clearance and tax declaration'
            }],
            value: '',
            btnList: [{
                id: 0,
                icon: require("../assets/images/icon_6.png"),
                text: "综合服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_7.png"),
                text: "金融服务"
            }, {
                id: 0,
                icon: require("../assets/images/icon_8.png"),
                text: "物流服务"
            }],
            default_icon: top_default,
            active_icon: top_active
        }
    },
    created() {
        let curr = this.vdata;
        let result = [];
        //console.log(curr,"curr")
        curr.forEach((item, index) => {
            if (index % 2 == 0) {
                result.push(item);
            }
        })
        this.list = result;
        console.log(this.list, "vdata")
    },
    methods: {
        changImg(e) {
            let child = this.imgsList.shift();
            this.imgsList.push(child)
        },
        changImgPrev() {
            let child = this.imgsList.pop();
            this.imgsList.unshift(child)
        },
        closeForm() {
            this.showPopuer = false;
        },
        openForm() {
            // this.showPopuer = true;
            window.open("https://mladm.scitcs.com/login?redirect=%2Findex")
        },
        last() {
            this.textList.forEach((item, index) => {
                let currId = null;
                if (item.isShow == true) {
                    currId = item.id
                }
                item.isShow = false;
                if (item.id == currId && currId == 0) {
                    console.log(item.id, currId);
                    console.log(this.textList[2])
                    this.$set(this.textList, 2, {
                        id: 2,
                        title: item.title,
                        text: item.text,
                        isShow: true
                    })
                }

            })
            console.log(this.textList)
        },
        changeNavFin(temp) {
            this.FinNavList.forEach((item, index) => {
                if (item.id == temp.id) {
                    this.$set(this.FinNavList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                        icon: item.icon
                    })
                } else {
                    this.$set(this.FinNavList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                        icon: item.icon
                    })
                }
            })
        },
        changeNav(temp) {
            this.childnavList.forEach((item, index) => {
                if (item.id == temp.id) {
                    this.$set(this.childnavList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: true,
                        icon: item.icon
                    })
                } else {
                    this.$set(this.childnavList, index, {
                        id: item.id,
                        text: item.text,
                        isClick: false,
                        icon: item.icon
                    })
                }
            })
        },
        changeItem(item) {
            this.navList.forEach((temp, num) => {
                if (temp.id == item.id) {
                    this.$set(this.navList, num, {
                        id: temp.id,
                        text: temp.text,
                        isClick: true
                    })
                } else {
                    this.$set(this.navList, num, {
                        id: temp.id,
                        text: temp.text,
                        isClick: false
                    })
                }
            })
            console.log(this.navList)
        },
        goPage() {
            window.open("http://mladm.scitcs.com/")
        },
        changeTag(item) {
            let curr = this.vdata;
            curr.forEach((tem, index) => {
                console.log(tem.id, item.id)
                if (tem.id == item.id) {
                    console.log(11111)
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: true,
                    }
                } else {
                    curr[index] = {
                        id: tem.id,
                        text: tem.text,
                        isText: tem.isText,
                        isShow: tem.isShow,
                        hasClass: false,
                    }
                }
            })
            let result = [];
            curr.forEach((item, index) => {
                if (index % 2 == 0) {
                    result.push(item);
                }
            })
            this.list = result;
            this.$emit('godata', {
                item,
                index: item.id
            })
            console.log(curr, "curr")
        }
    }

}
</script>

<style lang="less" scoped>
.user-popuer {
    .close-icon-box {
        position: absolute;
        top: -40px;
        right: 10px;
        width: 36px;
        width: 36px;

    }

    position: absolute;
    width: 620px;
    height: 560px;
    padding: 40px;
    background: #FFFFFF;
    border-radius: 0px 16px 0px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-box {
        width: 50%;
        height: 100%;
        //border: 1px red solid;

        .title-left {
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 33px;
            text-align: justify;
        }

        .sec-title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-bottom: 30px;
        }

        .labels-box {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #000000;
            line-height: 20px;
            margin-bottom: 10px;
        }

        .submit-btn {
            width: 100%;
            margin-top: 30px;
            color: white;
            height: 50px;
            background-color: #CC1F37;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .select-box {
            //border:1px red solid;
            width: 100%;
        }
    }

    .right-box {
        width: 45%;
        height: 100%;
        padding-top: 16px;
        padding-left: 29px;
        display: flex;
        flex-direction: column;

        .right-title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FF6600;
            line-height: 28px;
        }

        .right-text {
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
            line-height: 28px;
            margin-bottom: 20px;
        }

        .list-right-box {
            width: 100%;
            //border: 1px red solid;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: flex-start;
            //background-color: #ccc;
            border-radius: 5px;
            margin-top: 30px;

            .item-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 30px;

                .item-child-box {
                    margin-left: 26px;

                    .main-title {
                        font-size: 15px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        line-height: 21px;
                    }

                    .info-text {
                        font-size: 13px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 18px;
                    }
                }
            }
        }

        //border: 1px red solid;
    }
}

.titile-nav-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.btnsList {
    display: flex;
    justify-content: space-around;
    align-items: center;

    //border:1px red solid;
    .btn-child {
        //width: 98px;
        //height: 32px;
        padding: 18px 10px;
        //background: #CC1F37;
        border-radius: 19px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 32px;

    }
}

.active-btn {
    background: #CC1F37;
}

.active-nav {
    background: linear-gradient(135deg, rgba(182, 32, 32, 0.8) 0%, rgba(255, 255, 255, 0.1) 100%);
    border-radius: 0px 16px 0px 16px;
    width: 100%;
}

.top-nav {
    color: white;
    //border-radius: 5px;
    //border-top: 1px #ccc solid;
    border-bottom: 1px #ccc solid;
    position: relative;
    z-index: 999;
}

.active_border {
    border-bottom: 3px white solid;
}

.active-icon {
    width: 22px !important;
    height: 22px !important;
}

.mgt80 {
    margin-top: 80px;
}

.content-main {
    //background-color: yellowgreen;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .left-main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .left-main-content {
            width: 1440px;
            height: 100%;
            display: flex;
            flex-direction: column;
            //border: 1px red solid;

            .top-nav {
                width: 100%;
                height: 53px;
                //border: 1px red solid;
                margin-top: 20px;
                display: flex;
                justify-content: center;
                align-items: center;

                .child-nav {
                    position: relative;
                    z-index: 100000;
                    font-size: 25px;
                    color: white;
                    margin-right: 30px;
                    //border:1px red solid;
                    //height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;

                    &:last-child {
                        margin-right: 0px;
                    }
                }

            }

        }

        .left-main-box {
            display: flex;
            flex: 1;
            //border: 1px red solid;
            justify-content: space-between;
            align-items: flex-start;
            width: 100%;

            .left-main-text {
                width: 50%;
                height: 300px;
                background: #FFFFFF;
                border-radius: 0px 16px 0px 16px;
                //border:1px red solid;
                margin-right: 20px;
                padding: 50px 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left-main-left {
                    width: 60%;
                    height: 100%;
                    border-right: 1px #E6E6E6 dashed;
                    padding: 0 30px;

                    .left-title {
                        font-size: 24px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #000000;
                        line-height: 33px;
                    }

                    .info {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #666666;
                        line-height: 20px;
                        margin-bottom: 25px;
                    }

                    .labels-box {
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: bold;
                        color: #000000;
                        line-height: 20px;
                        margin-bottom: 10px;
                    }
                }

                .left-main-right {
                    width: 40%;
                    height: 100%;
                    //border: 1px red solid;
                    padding-top: 16px;
                    padding-left: 29px;
                    display: flex;
                    flex-direction: column;

                    .right-title {
                        font-size: 20px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FF6600;
                        line-height: 28px;
                    }

                    .right-text {
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                        line-height: 28px;
                        margin-bottom: 20px;
                    }
                }
            }

            .left-main-imgs {
                margin-left: 20px;
                width: 50%;
                height: 300px;
                padding: 50px 30px;
                //background: #FFFFFF;
                //border:1px red solid;
                background: #FFFFFF;
                display: flex;
                flex-direction: column;
                border-radius: 0px 16px 0px 16px;

                .right-title {
                    font-size: 30px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #000000;
                    line-height: 42px;
                    margin-bottom: 16px;
                }

                .lines {
                    width: 100%;
                    height: 2px;
                    background-color: #F3F4F5;

                    .child-line {
                        width: 180px;
                        height: 2px;
                        background: #CC1F37;
                    }
                }

                .list-news-box {

                    display: flex;
                    flex: 1;
                    //border: 1px red solid;
                    margin-top: 24px;

                    .ul-box {
                        //margin-left: 10px;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }

    .right-main {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        padding-right: 60px;

        //background-color: rgb(167, 164, 164);
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .tagLabel-box {
            width: 40px;
            height: 100%;
            // margin-top: 160px;
            //border: 1px red solid;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;

            .label-top {
                width: 100%;
                height: 30%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;

                //border: 1px green solid;

                .icon-item {
                    width: 8px;
                    height: 8px;
                    background-size: cover;
                    background-position: center center;
                }
            }

            .label-bottom {
                width: 100%;
                height: 30%;
                //border: 1px green solid;

                .label-bottom-top {
                    width: 100%;
                    height: 80%;
                    //border: 1px red solid;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .label-bottom-bottom {
                    width: 100%;
                    height: 20%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    //border:1px red solid;
                }
            }
        }
    }
}

.colorFB092B {
    color: #FB092B;
}

.title {

    font-size: 50px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 84px;
}

.submit-btn {
    width: 100%;
    margin-top: 30px;
    color: white;
    height: 50px;
    background-color: #CC1F37;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sec-title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    line-height: 26px;
    text-align: justify;
}

.text-title {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 42px;
}

.select-box {
    //border:1px red solid;
    width: 100%;
}

.link-box {
    color: #CC1F37;
}

.li-child {
    width: 100% !important;
    display: flex;
    height: 40px;
    justify-content: flex-start;
    align-items: center;
    //border: 1px red solid;

    .text-child {
        width: 60%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        //border:1px red solid;
    }

    .date-child {
        width: 30%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        //border:1px red solid;
    }

    .btns-child {
        width: 10%;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
        //border:1px red solid;
        text-align: right;
    }
}

.list-right-box {
    width: 100%;
    //border: 1px red solid;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
    //background-color: #ccc;
    border-radius: 5px;

    .item-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .item-child-box {
            margin-left: 26px;

            .main-title {
                font-size: 15px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 21px;
            }

            .info-text {
                font-size: 13px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 18px;
            }
        }
    }
}

.texts {
    width: 340px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: justify;
}

.mgt15 {
    margin-top: 15px;
}

.btns {
    width: 118px;
    height: 42px;
    background: #CC1F37;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.btns-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .pages {
        color: #333333;
        font-size: 14px;
    }
}

.mgb40 {
    margin-bottom: 40px;
}

.mgt40 {
    margin-top: 40px;
}

.mgt60 {
    margin-top: 60px;
}

.mgb30 {
    margin-bottom: 30px;
}

.mgb100 {
    margin-bottom: 100px;
}

.mgr10 {
    margin-right: 10px;
}

.btn-go {
    width: 32px;
    height: 32px;
    background-color: #CC1F37;
    margin-top: 40px;
}

.default-child {
    width: 2px;
    height: 16%;
    background: rgba(255, 255, 255, 0.1);
}

.active-child {
    background: rgba(54, 169, 255, 0.5);
}

.color36A9FF {
    color: #36A9FF;
}

.text-video-box {
    margin-top: 20px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: space-between;
    align-items: flex-start;

    .left-nav-box {
        width: 30%;
        //height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;

        //border: 1px red solid;
        .nav-child {
            width: 80%;
            height: 100px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            //border: 1px red solid;
            padding-right: 30px;

            .child-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;

                .line {
                    width: 4px;
                    height: 40px;
                    background: #FFFFFF;
                    margin-right: 36px;
                }

                .triangle {
                    width: 15px;
                    height: 24px;
                    background-image: url("../assets/images/close.png");
                    margin-right: 36px;
                    background-repeat: no-repeat;
                    background-position: center center;
                    background-size: cover;
                }

                .child-text {
                    font-size: 24px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 33px;
                }
            }

            .imgs {
                width: 46px;
                height: 46px;
            }
        }
    }

    .right-child-box {
        width: 70%;
        //height: 100%;
        background: #FFFFFF;
        //margin-right: 50px;

        border-radius: 0px 16px 0px 16px;

        .childList {
            width: 90%;
            //padding: 50px;
            padding-top: 20px;
            padding-left: 50px;
            //padding: 20px;
            padding-bottom: 20px;
            padding-right: 50px;
            //border:1px red solid;

            .child-title {
                width: 100%;
                font-size: 20px;
                padding-left: 15px;
                line-height: 30px;
                /* background-color: #333; */
                border-left: 5px #b62020 solid;
                /* margin-left: 20px; */
                color: #333;
                margin-bottom: 15px;
                font-weight: bold;
                margin-top: 10px;
            }

            .server-img-box {
                width: 100%;
                margin-bottom: 10px;
            }

            .serverList_1 {
                list-style-type: none;
                margin-bottom: 10px;
                color: #333;
                font-size: 16px;
                line-height: 2;
            }

            .serverList_2 {
                list-style-type: none;
                color: #333;
                font-size: 13px;
                line-height: 2;
            }
        }
    }
}

.text-video-box_log {
    margin-top: 50px;
    display: flex;
    flex: 1;
    //border: 1px red solid;
    //min-height: 360px;
    justify-content: space-between;
    align-items: flex-start;

    .info-box {
        width: 496px;
        height: 420px;
        //border: 1px red solid;
        background: linear-gradient(135deg, #CC1F37 0%, rgba(152, 0, 35, 0) 100%);
        border-radius: 0px 16px 0px 16px;
        padding-top: 62px;
        padding-left: 80px;
        padding-right: 150px;
        display: flex;
        flex-direction: column;
        position: relative;

        .swiper-container {
            width: 100%;
            height: 100%;

            //border:1px red solid;
            overflow: hidden;

            .swiper-wrapper {
                //width: 200px !important;
                overflow: hidden;
                //border:1px red solid;
            }

            .swiper-slide {
                //width: 400px !important;
                //border: 1px red solid;
            }

            .swiper-button-next {
                top: 7% !important;
                right: 1%;
                color: white;
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-prev {
                //color:white;
                top: 7% !important;
                left: 646px !important;
                color: white;
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-prev::after {
                width: 32px !important;
                height: 32px !important;
            }

            .swiper-button-next:after {
                width: 32px !important;
                height: 32px !important;
            }
        }

        .info-title {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 42px;
            margin-top: 15px;
            margin-bottom: 20px;
        }

        .info-text {
            width: 320px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            margin-bottom: 10px;
        }

        .btns-go {
            width: 208px;
            //height: 42px;
            padding: 15px;
            background: #FFFFFF;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #B10F2C;
            line-height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }

        .imgs-list {
            width: 980px;
            height: 320px;
            position: absolute;
            top: 120px;
            right: -690px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            //border: 1px red solid;
            .imgs-child {
                width: 320px;
                height: 100%;
                margin-right: 15px;

                &:last-child {
                    margin-right: 0;
                }

                //border:1px red solid;
            }
        }

    }
}

@media (max-width: 768px) {
    .content-main {
        .left-main {
            .left-main-content {
                width: 80%;
                .titile-nav-box{
                .title{
                width: 30%;
                }
                .btnsList{
                width: 55%;
                overflow: scroll;
                justify-content: flex-start;
                }
                }

                .left-main-content-2 {
                    width: 100%;

                    .sec-title {
                        font-size: 12px;
                        line-height: 17px;
                    }

                    .text-video-box_log {
                        margin-top: 15px;

                        .info-box {
                            padding-top: 0px;
                            padding-right: 0px;
                            padding-left: 0px;
                            width: 100%;
                            .info-title{
                            margin-top: 4px;
                            margin-bottom: 0px;
                            font-size: 20px;
                            margin-left: 5px;
                            }
                            .info-text{
                            margin-left: 5px;
                            font-size: 14px;
                            }
                            .swiper-button-prev{
                            left: 230px !important;
                            }
                        }
                    }

                    .text-video-box {
                        margin-top: 10px;

                        .left-nav-box {
                            .nav-child {
                                width: 99%;
                                height: 73px;
                                padding-right: 5px;

                                .child-left {
                                    .line {
                                        margin-right: 6px;

                                    }

                                    .triangle {
                                        margin-right: 5px;
                                        height: 15px;
                                        background-size: contain;
                                    }
                                }

                                .child-text {
                                    font-size: 12px;
                                    line-height: 15px;

                                }
                                img{
                                width: 32px;
                                height: 32px;
                                position: relative;
                                left: -5px;
                                top:-20px
                                }
                            }
                        }

                        .right-child-box {
                            height: 350px;
                            overflow-x: scroll;
                            width: 68%;

                            .childList {
                                padding-top: 0px;
                                padding-left: 0px;
                                padding-right: 0px;
                                width: 100%;

                                .child-title {
                                    width: 90%;
                                    padding-left: 10px;
                                    margin-bottom: 5px;
                                    margin-left: 5px;
                                }

                                .server-img-box {
                                    img {
                                        width: 99% !important;
                                        margin-left: 10px;
                                    }
                                }

                                .serverList_1 {
                                    padding: 0 10px;
                                    font-size: 13px;
                                    line-height: 18px;
                                }

                                .serverList_2 {
                                    padding: 0 10px;
                                    font-size: 13px;
                                    line-height: 18px;
                                }
                            }
                        }
                    }
                }

                .titile-nav-box {
                    .title {
                        font-size: 15px;
                        line-height: 25px;
                    }

                    .btnsList {
                        .btn-child {
                            margin-left: 3px;
                            padding: 6px 8px;
                        }
                    }
                }

                .left-main-box {
                    .left-main-content-2 {
                        width: 100%;

                        .sec-title {
                            font-size: 12px;
                            line-height: 17px;
                        }

                        .text-video-box {
                            margin-top: 10px;

                            .left-nav-box {
                                .nav-child {
                                    width: 94%;
                                    height: 73px;
                                    padding-right: 5px;

                                    .child-left {
                                        .line {
                                            margin-right: 6px;

                                        }

                                        .triangle {
                                            margin-right: 5px;
                                            height: 15px;
                                            background-size: contain;
                                        }
                                    }

                                    .child-text {
                                        font-size: 12px;
                                        line-height: 15px;

                                    }
                                }
                            }

                            .right-child-box {
                                height: 350px;
                                overflow-x: scroll;
                                width: 68%;

                                .childList {
                                    padding-top: 0px;
                                    padding-left: 0px;
                                    padding-right: 0px;
                                    width: 100%;

                                    .child-title {
                                        width: 90%;
                                        padding-left: 10px;
                                        margin-bottom: 5px;
                                        margin-left: 5px;
                                    }

                                    .server-img-box {
                                        img {
                                            width: 93% !important;
                                            margin-left: 10px;
                                        }
                                    }

                                    .serverList_1 {
                                        padding: 0 10px;
                                        font-size: 13px;
                                        line-height: 18px;
                                    }

                                    .serverList_2 {
                                        padding: 0 10px;
                                        font-size: 13px;
                                        line-height: 18px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }

        .right-main {
            padding-right: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/tagSupply.vue